import React, { PropTypes } from "react";
import update from "react-addons-update";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  reduxForm,
  change as changeFieldValue,
  SubmissionError,
} from "redux-form";
import { FormattedMessage } from "react-intl";

import { ClientAttachment } from "./";
import * as dataActions from "../../../../../utils/data/dataActions";

import validationUtils from "../../../../../utils/ValidationUtils";
import { CLIENT_ATTACHMENTS } from "../../../../../utils/data/models";
import { CLIENT_ATTACHMENTS_VALIDATION_RULES } from "./clientAttachmentsValidationRules";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";

import keycloakManager from "../../../../login/sso/keycloakManager";
import { MessageBox } from "../../../../common";
import { getSessionCookies, setSessionCookies } from "../../../../common/sessions/tokenHelper";
import { getTenantFromURL } from "../../../../common/MultiTenancy/MultiTenancyHelper";

class BasicClientAttachmentFields extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      clientAttachments: [],
      tokenRefreshed: false,
    };

    this.handleAttachmentDelete = this.handleAttachmentDelete.bind(this);
    this.handleAttachmentDownload = this.handleAttachmentDownload.bind(this);
    this.handleAttachmentDownloaded = this.handleAttachmentDownloaded.bind(
      this
    );
    this.handleUploadFinish = this.handleUploadFinish.bind(this);
  }

  componentDidMount() {
    let [accessToken, refreshToken] = getSessionCookies();

    keycloakManager.refreshTokens(accessToken, refreshToken).then((data) => {
      [accessToken, refreshToken] = data;
      setSessionCookies(accessToken, refreshToken);
      this.setState({tokenRefreshed: true});
    }).catch(() => {
      this.setState({tokenRefreshed: true});
    });
  }
  
  componentDidUpdate(){
    
    if(this.props.shortLivedURL){
      
      if(this.props.successDownloads.length > 0){
        let finishedDownloadObj = this.props.successDownloads.find(download => download.path == this.props.shortLivedURL);

        if(finishedDownloadObj){
          this.handleAttachmentDownloaded();
        }
      }
      if(this.props.errorDownloads.length > 0){
        
        let finishedDownloadObj = this.props.errorDownloads.find(download => download.path == this.props.shortLivedURL);
        
        if(finishedDownloadObj){
          this.handleAttachmentDownloaded();
        }
       
      }
    }
  }

  handleAttachmentDelete(deletedFile, e) {
    e.stopPropagation();
    const objectIndex = this.state.clientAttachments.findIndex(
      (item) => item.objectName === deletedFile.objectName
    );
    this.setState(
      {
        clientAttachments: update(this.state.clientAttachments, {
          $splice: [[objectIndex, 1]],
        }),
      },
      () =>
        this.props.changeFieldValue(
          "clientAttachment",
          "clientAttachments",
          this.state.clientAttachments
        )
    );
  }

  handleUploadFinish(uploadedFile) {
    this.setState(
      {
        clientAttachments: update(
          !!this.state.clientAttachments ? this.state.clientAttachments : [],
          {
            $push: [
              {
                ...uploadedFile,
                clientId: this.props.initialValues.clientId,
                createdByUserId: this.props.auth.user.userId,
                status: "UPLOADED",
              },
            ],
          }
        ),
      },
      () =>
        this.props.changeFieldValue(
          "clientAttachment",
          "clientAttachments",
          this.state.clientAttachments
        )
    );
  }

  handleAttachmentDownloaded() {
    this.props.dataActions.clearS3DataFile(CLIENT_ATTACHMENTS);
  }

  handleAttachmentDownload(options) {
    if (options.objectPath.startsWith(`${getTenantFromURL()}/`)) {
      options.objectPath = options.objectPath.replace(`${getTenantFromURL()}/`,'');
    }
    const query = {
      clientMethod: "get_object",
      objectPath: options.objectPath,
      objectName: options.objectName,
      regionName: options.regionName,
      bucketName: options.bucketName,
    };
    return this.props.dataActions
      .getS3DataFile(
        { ...CLIENT_ATTACHMENTS, path: CLIENT_ATTACHMENTS.signingPath },
        "",
        query,
        null
      )
      .then((result) => {
        if (result.payload.error) {
          throw new SubmissionError({
            _error: result.payload.error.data.error,
          });
        }
      });
  }

  render() {
    return (
      <div>
        {this.state.tokenRefreshed &&(
          <form onSubmit={this.props.handleSubmit}>
            <MessageBox className="alert-info">
                <FormattedMessage id="clientAttachments.modal.fileDepositWarning" />
              </MessageBox>
            <fieldset className="sub-group">
              <ClientAttachment
                clientGuid={this.props.initialValues.clientGuid}
                clientAttachments={this.state.clientAttachments}
                clientId={this.props.initialValues.clientId}
                shortLivedURL={this.props.shortLivedURL}
                handleAttachmentDownload={this.handleAttachmentDownload}
                handleAttachmentDownloaded={this.handleAttachmentDownloaded}
                handleAttachmentDelete={this.handleAttachmentDelete}
                handleUploadFinish={this.handleUploadFinish}
                />
            </fieldset>
          </form>
        )}
      </div>
    );
  }
}

BasicClientAttachmentFields.propTypes = {
  auth: PropTypes.object,
  changeFieldValue: PropTypes.func,
  dataActions: PropTypes.object,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  shortLivedURL: PropTypes.string,
  validation: PropTypes.object,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  handleAttachmentDownloaded: PropTypes.func,
};

function mapStateToProps(state) {
  const file = state.data.clientAttachments || { shortLivedURL: null };
  const downloads = state.downloader || {};

  return {
    auth: state.auth || {},
    shortLivedURL: !!file.shortLivedURL ? file.shortLivedURL.signedUrl : null,
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "clientAttachment",
    validate: (values) =>
      validationUtils.validate(values, CLIENT_ATTACHMENTS_VALIDATION_RULES),
  })(BasicClientAttachmentFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientAttachments/BasicClientAttachmentFields.js